var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"outlined":"","placeholder":"дд.мм.гггг","maxlength":"10","label":_vm.label,"rules":_vm.dateRules},on:{"input":function($event){return _vm.formatDate($event)},"keydown":function($event){return _vm.handleKeyDown($event)}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }